import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GroupService } from 'src/app/services/user/group.service';
import { Group } from '@ascschool/model/user/group.model';
import { PopUpNguoiDungHeThongComponent } from './pop-up-nguoi-dung-he-thong/pop-up-nguoi-dung-he-thong.component';
import { BoardService } from '@ascschool/services/category/board.service';
import { PositionService } from '@ascschool/services/category/position.service';
import { SystemUserService } from '@ascschool/services/user/system-user.service';
import { ThemNguoiDungHeThongComponent } from './them-nguoi-dung-he-thong/them-nguoi-dung-he-thong.component';
import { PhanQuyenNguoiDungHeThongComponent } from './phan-quyen-nhom-nguoi-dung/phan-quyen-nhom-nguoi-dung.component';
import { QuanLyDanhSachNguoiDungHeThongComponent } from './quan-ly-danh-sach-co-so/quan-ly-danh-sach-co-so.component';
import { PhanNhomQuyenComponent } from './phan-nhom-quyen/phan-nhom-quyen.component';
import { PositionGVService } from '@ascschool/services/category/position-gv.service';

@Component({
  selector: 'app-nguoi-dung-he-thong',
  templateUrl: './nguoi-dung-he-thong.component.html',
  styleUrls: ['./nguoi-dung-he-thong.component.scss']
})
export class NguoiDungHeThongComponent implements OnInit, AfterViewInit {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  titlePopup: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  constructor(
    private msg: NzMessageService, private cdRef: ChangeDetectorRef, public _authService: AuthService,
    public sizePageService: SizePageService, private modalService: NzModalService, private authQuery: AuthQuery,
    private boardService: BoardService, private groupService: GroupService, private positionService: PositionService, private positionGVService: PositionGVService,
    private utilsService: UtilsService, private service: SystemUserService, public utilService: UtilsService
  ) { }
  get breadcrumbs(): string[] {
    return ['Quản trị hệ thống'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  heightModal: string;
  widthModal: string;
  searchTerm: string = '';
  pageIndex: number = 1;
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[2];
  loading: boolean = true;
  Total: number = 0;
  firstRowOnPage: any;
  searchAdvanced = true;
  checkedAll: boolean = false;
  commonFilter = new CommonFilter();
  systemuserList: any;
  listGroupSelected: number[] = [];
  getGroupACFn: (value: any) => Observable<any>;
  groupSubscription: any;
  groupControl = new FormControl();
  getBoardACFn: (value: any) => Observable<any>;
  boardSubscription: any;
  boardControl = new FormControl();
  getPositionACFn: (value: any) => Observable<any>;
  positionSubscription: any;
  positionControl = new FormControl();
  getPositionGVACFn: (value: any) => Observable<any>;
  positionGVSubscription: any;
  positionGVControl = new FormControl();
  currentUser: any;
  checked = false;
  indeterminate = false;
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set<number>();
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  totalSchool: number;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;

  sortNameFn = (a: Group, b: Group) => a.groupName.localeCompare(b.groupName);
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[2];
    this.commonFilter.isActivity = '';
    this.reload();
    this.loadGroup();
    this.loadBoard();
    this.loadPosition();
    this.loadPositionGV();
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe((item) => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.systemuserList = [];
    this.service.getSystemUsers(this.commonFilter).subscribe(
      (response: any) => {
        const list = response.results ? response.results : [];
        this.Total = (response && response.rowCount) ? response.rowCount : 0;
        this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
        _this.systemuserList = (list) ? list : [];
        _this.loading = false;
      }, (err: any) => {
        _this.systemuserList = [];
        _this.loading = false;
      }
    );
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'], label: 'Help', description: 'Cmd + b', command: (e) => this.AddGroup(), preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  clear() {
    this.groupControl.setValue(null);
    this.boardControl.setValue(null);
    this.positionControl.setValue(null);
    this.commonFilter.StaffCode = '';
    this.commonFilter.UserName = '';
    this.commonFilter.FullName = '';
    this.commonFilter.StaffCode = '';
    this.commonFilter.isActivity = '';
    this.commonFilter.NormalizedUserName ='';
    delete this.commonFilter.Gender;
    this.reload();
  }
  //popup
  showPopup(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup = 'Chỉnh sửa người dùng hệ thống';
    this.widthModal = 1300 + 'px';
    this.heightModal = 'auto';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopUpNguoiDungHeThongComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
      },
      nzComponentParams: {
        dataTransmission: item,
      },
      nzWidth: this.widthModal
    });
    this.dialogRef.afterClose.subscribe(result => {
      if (result) {
        this.reload();
      }
    });
  }
  AddGroup() {
    this.isResizdePopup = false;
    this.titlePopup = 'Thêm người dùng hệ thống';
    this.widthModal = 1300 + 'px';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: ThemNguoiDungHeThongComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.caculateHeightPopup(window.innerHeight) + 'px'
      },
      nzComponentParams: {

      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe(result => {
      if (result) {
        this.reload();
      }
    });
  }
  EditGroup(item: any) {
    this.showPopup(item);
  }

  viewManageSchool(item: any) {
    this.isResizdePopup = false;
    this.titlePopup = 'Danh sách cơ sở quản lý';
    this.widthModal = 1300 + 'px';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PhanQuyenNguoiDungHeThongComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.caculateHeightPopup(window.innerHeight) + 'px'
      },
      nzComponentParams: {
        dataTransmission: item,
      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe(result => {
      if (result) {
        this.reload();
      }
    });
  }

  addSchool(item: any) {
    this.isResizdePopup = false;
    this.titlePopup = 'Chọn cơ sở quản lý';
    this.widthModal = 1300 + 'px';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: QuanLyDanhSachNguoiDungHeThongComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.caculateHeightPopup(window.innerHeight) + 'px'
      },
      nzComponentParams: {
        dataTransmission: item,
      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe(result => {
      if (result) {
        this.reload();
      }
    });
  }
  phanNhomQuyen() {
    this.isResizdePopup = false;
    this.titlePopup = 'Chọn nhóm quyền';
    this.listGroupSelected = [];
    this.setOfCheckedId.forEach(item => {
      this.listGroupSelected.push(item);

    });
    if (this.listGroupSelected !== null && this.listGroupSelected.length > 0) {
      this.widthModal = 700 + 'px';
      this.heightModal = 'auto';
      this.dialogRef = this.modalService.create({
        nzTitle: this.titlePopupElement,
        nzContent: PhanNhomQuyenComponent,
        nzStyle: { top: '30px' },
        nzMaskClosable: false,
        nzBodyStyle: {
          overflow: 'auto',
        },
        nzComponentParams: {
          lstIdGroup: this.listGroupSelected,
        },
        nzWidth: 700
      });
      // const instance = dialogRef.getContentComponent();
      this.dialogRef.afterClose.subscribe(result => {
        if (result) {
          this.reload();
        }
      });
    } else {
      this.msg.warning('Vui lòng chọn người dùng');
    }
  }


  deleteMulti(): void {
    this.listGroupSelected = [];
    this.setOfCheckedId.forEach(item => {
      this.listGroupSelected.push(item);
    });
    if (this.listGroupSelected.length > 0) {
      const dialogRef = this.modalService.create({
        nzTitle: 'Xóa người dùng hệ thống',
        nzContent: ConfirmComponent,
        nzComponentParams: {
          description: 'người dùng đã chọn'
        },
        nzStyle: { top: '20px' },
        nzMaskClosable: false
      });
      dialogRef.afterClose.subscribe((result) => {
        if (result)
          this.service.deleteMulti(this.listGroupSelected).subscribe((res: any) => {
            if (res.statusCode == 0) {
              this.utilService.notifyResponse(res);
              this.reload();
            } else {
              this.utilService.notifyResponse(res);
            }
          });
      });
    } else {
      this.msg.warning('Vui lòng chọn người dùng để xóa!');
    }
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  loadGroup() {
    this.getGroupACFn = (value: any) => this.groupService.GetSelectPagingCreateByGroup({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.groupName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.groupSubscription) this.groupSubscription = this.groupControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'GroupId', this.groupControl.value);
    });
  }
  changeGroup(control: FormControl) {
    this.groupControl = control;
  }

  loadBoard() {
    this.getBoardACFn = (value: any) => this.boardService.getBoardSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.boardName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.boardSubscription) this.boardSubscription = this.boardControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'BoardId', this.boardControl.value);
    });
  }
  changeBoard(control: FormControl) {
    this.boardControl = control;
  }
  loadPosition() {
    this.getPositionACFn = (value: any) => this.positionService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.positionName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.positionSubscription) this.positionSubscription = this.positionControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'PositionId', this.positionControl.value);
    });
  }
  changePosition(control: FormControl) {
    this.positionControl = control;
  }
  
  loadPositionGV() {
    this.getPositionGVACFn = (value: any) => this.positionGVService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.positionGVName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.positionGVSubscription) this.positionGVSubscription = this.positionGVControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.commonFilter, 'PositionGVId', this.positionGVControl.value);
    });
  }
  changePositionGV(control: FormControl) {
    this.positionGVControl = control;
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: any[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  exportExcel() {
    // document.getElementById('btnvF').click();

    this.service.exportExcel(this.commonFilter).subscribe((data) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'DanhSachNguoiDungHeThong.xlsx';
      link.click();
    });
  }
  handlerResizePopup() {
    this.isResizdePopup = !this.isResizdePopup;
    let width = this.widthModal;
    let height = this.heightModal;
    let top = 30;
    if (this.isResizdePopup === true) {
      width = window.innerWidth + 'px';
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width,
      nzStyle: {
        top: top + 'px',
      },
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: height,
        height: height,
      }
    });
  }
}
